import { Dispatch, useState } from 'react';

export type UseSearch = [string, Dispatch<string>];

const useSearch = (): UseSearch => useState('');

export default useSearch;
